//#region src/types/value/link.ts
/** Link types */
const LinkType = {
	Any: "Any",
	Document: "Document",
	Media: "Media",
	Web: "Web"
};
//#endregion
exports.LinkType = LinkType;

//# sourceMappingURL=link.cjs.map